/**
 * Widget V2 — Events (a standalone class category)
 *
 * A class category other than the club's Group Classes (Events, Camps…) runs
 * only a handful of dates a year, so it gets its own page: every upcoming date
 * for the next year in one list, grouped by month, narrowed by event and by a
 * picker of the days that have events. A row opens the class session page,
 * which owns joining.
 */

import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import { DataView, EmptyState } from "/imports/ui/components/shared";
import { PageHeading, SECTION_LABEL_SX } from "/imports/ui/components/discovery";
import useEvents from "./useEvents";
import EventRow from "./components/EventRow";
import EventDateStrip from "./components/EventDateStrip";
import EventFilters from "./components/EventFilters";

function EventsView() {
  const ev = useEvents();

  return (
    <Box>
      <PageHeading title={ev.categoryName} subtitle="Upcoming dates you can sign up for." onBack={ev.goBack} />

      <DataView loading={ev.loading} error={ev.error} data={ev.data} loadingMessage="Loading dates...">
        <EventFilters defs={ev.filterDefs} />
        <EventDateStrip dates={ev.eventDates} selectedDate={ev.selectedDate} totalEvents={ev.totalEvents} onSelect={ev.selectDate} />

        {ev.eventsByMonth.length > 0 ? (
          ev.eventsByMonth.map(({ month, label, items }) => (
            <Box key={month} sx={{ mb: { xs: 3, md: 4 } }}>
              <Typography sx={{ ...SECTION_LABEL_SX, mb: 1.5 }}>{label}</Typography>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                {items.map((event) => (
                  <EventRow
                    key={event._id}
                    event={event}
                    currency={ev.currency}
                    onOpen={() => ev.openEvent(event)}
                    onJoin={() => ev.handleJoin(event)}
                  />
                ))}
              </Box>
            </Box>
          ))
        ) : ev.hiddenByLevel > 0 ? (
          <EmptyState
            title="No events at your level"
            description={`${ev.hiddenByLevel} ${ev.hiddenByLevel === 1 ? "event is" : "events are"} coming up for other levels.`}
            actionLabel="Show all levels"
            onAction={ev.showAllLevels}
          />
        ) : (
          <EmptyState
            title="No upcoming dates"
            description="New dates show up here as soon as the club adds them."
            actionLabel="Back to home"
            onAction={ev.goHome}
          />
        )}
      </DataView>
    </Box>
  );
}

export default EventsView;
